import React, { useState, useEffect } from 'react'
import css from '../css/gamehis.module.css'
import ReactPaginate from 'react-paginate'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { BsChatDots } from 'react-icons/bs'
// import Header from "../Components/Header";
import Rightcontainer from '../Components/Rightcontainer'
import axios from 'axios'
import socket from '../Components/socket'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import { toggleWidget } from 'react-chat-widget'
import { apiRequest } from '../../apiService/allApi'
import { Margin } from '@mui/icons-material'

const Gamehistory = ({ TicketList, Conversation }) => {
  // console.log(Conversation)
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [user, setUser] = useState()
  let limit = 50
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    // await axios
    //   .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    //Allgames(res.data._id)
    Allgames(res.data._id, pageNumber, limit)
    // window.location.reload()
    // })
  }

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)

  }
  const [game, setGame] = useState([])
  // console.log(game)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)

    try {
      const res = await apiRequest(`game/history/user/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      let gameHis = []
      res.data.data.forEach(ele => {
        if (
          ele.Status == 'completed' ||
          ele.Status == 'cancelled' ||
          ele.Status == 'conflict'
        ) {
          gameHis.push(ele)
        }
      })
      setGame(gameHis)
      setNumberOfPages(res.data.totalPages)
      setIsLoading(false)
    } catch (e) {
    }
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [pageNumber, limit])


  // All history Api 

  // UserList

  const UserList = async id => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`)

    var urlencoded = new URLSearchParams()
    // urlencoded.append("agent_id", "63b5340bc5d2b82e4652b216");
    urlencoded.append('supportType', 'game')
    urlencoded.append('issue', id)

    const res = await apiRequest('chat/genrate-ticket', "POST", urlencoded, myHeaders)
    // .then(response => response.json())
    // toggleWidget()
    TicketList()
    Conversation()

    toast
      .success('Your Ticket Generate Sucessfully')
      .then(result => console.log(result))
    toast
      .error('Something Went Wrong')
      .catch(error => console.log('error', error))
  }

  // change theme 
  const theme = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme === 'light' ? '#d3e2fc' : 'black',
    color: theme === 'light' ? 'black' : '#fff',

  };

  return (
    <div>
      <div className='leftContainer ' >
        <div className="prince_game_history_list">

          {/* GAME HISTORY */}

          {isLoading ? (

            <div className="prince_game_loading">

              <div
                className="prince_game_loader_box"
                style={{ zIndex: "99" }}
              >
                <img
                  src="/images/LandingPage_img/loader1.gif"
                  alt="Loading"
                />
              </div>

            </div>

          ) : game && game?.length == 0 ? (

            <div className="prince_game_empty">

              <img
                src="./images/not-found.gif"
                alt="no data"
              />

              <div className="prince_game_empty_text">

                <h3>
                  No Game History
                </h3>

                <p>
                  You have no game history yet.
                </p>

              </div>

            </div>

          ) : (

            game &&
            game.map(card => (

              <div
                className="prince_game_history_card"
                key={card?._id}
              >

                {/* =========================================
            STATUS HEADER
        ========================================= */}

                <div
                  className={`prince_game_status_banner ${card?.Status === "completed"
                    ? card?.Winner && card?.Winner?._id === user._id
                      ? "prince_game_status_win"
                      : "prince_game_status_loss"
                    : "prince_game_status_pending"
                    }`}
                >

                  <span className="prince_game_status_dot"></span>

                  <b className="prince_game_status_text">

                    {card?.Status === "completed"
                      ? card.Winner && card?.Winner?._id === user._id
                        ? "WINNER"
                        : "LOSER"
                      : card?.Status.toUpperCase()}

                  </b>

                </div>


                {/* =========================================
            MAIN CONTENT
        ========================================= */}

                <div className="prince_game_history_body">


                  {/* LEFT */}

                  <div className="prince_game_history_left">

                    {/* ROOM */}

                    <div className="prince_game_history_item">

                      <span className="prince_game_history_label">
                        ROOM
                      </span>

                      <strong className="prince_game_room">
                        {card?.Room_code}
                      </strong>

                    </div>


                    {/* GAME */}

                    <div className="prince_game_history_item">

                      <span className="prince_game_history_label">
                        GAME RESULT
                      </span>

                      <div className="prince_game_result">

                        <span>

                          {card?.Status === "completed"
                            ? card?.Winner && card?.Winner?._id === user._id
                              ? "Win"
                              : "Loss"
                            : card?.Status}

                        </span>

                        <strong>
                          ₹{card?.Game_Ammount}
                        </strong>

                      </div>

                    </div>

                  </div>


                  {/* RIGHT */}

                  <div className="prince_game_history_right">

                    {/* WIN AMOUNT */}

                    <div className="prince_game_history_item prince_game_win_item">

                      <span className="prince_game_history_label">
                        WIN AMOUNT
                      </span>

                      <strong className="prince_game_win_amount">
                        ₹{card?.winnAmount}
                      </strong>

                    </div>


                    {/* CLOSING BALANCE */}

                    <div className="prince_game_history_item">

                      <span className="prince_game_history_label">
                        CLOSING BALANCE
                      </span>

                      <strong className="prince_game_closing_balance">

                        {(card?.Acceptor_status == "cancelled" &&
                          card?.Accepetd_By?.id === user.id) ? (

                          card?.Winner_closingbalance

                        ) : card?.Creator_Status == "cancelled" ? (

                          card?.Loser_closingbalance

                        ) : card?.Winner?.id === user._id ? (

                          card?.Winner_closingbalance

                        ) : (

                          card?.Loser_closingbalance

                        )}

                      </strong>

                    </div>

                  </div>

                </div>


                {/* =========================================
            FOOTER
        ========================================= */}

                <div className="prince_game_history_footer">

                  <div className="prince_game_date">

                    <span className="prince_game_date_icon">
                      📅
                    </span>

                    <span>
                      {dateFormat(card?.createdAt).split(",")[0]}
                    </span>

                  </div>

                  <span className="prince_game_time">

                    @
                    {dateFormat(card?.createdAt).split(",")[1]}

                  </span>

                </div>

              </div>

            ))

          )}

        </div>
      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}

export default Gamehistory
